import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PageLayout from './PageLayout';
import { useAuth } from '../auth/AuthProvider';
import { brandColors } from '../Theme';
import { galiaEyebrowSx, galiaNavButtonSx } from '../theme/galiaUi';

type AdminLayoutProps = {
    children: React.ReactNode;
};

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
    const { user, signOut } = useAuth();
    const location = useLocation();
    const isHome = location.pathname === '/admin';
    const isLitters =
        location.pathname === '/admin/litters' || location.pathname === '/admin/owners';
    const isInvite = location.pathname === '/admin/invite';

    return (
        <PageLayout>
            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={2}
                justifyContent="space-between"
                alignItems={{ xs: 'flex-start', sm: 'center' }}
                sx={{
                    mb: 4,
                    pb: 2.5,
                    borderBottom: '1px solid rgba(15, 23, 42, 0.08)',
                }}
            >
                <Box>
                    <Typography component="p" sx={{ ...galiaEyebrowSx, mb: 0.5 }}>
                        Admin
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '0.9375rem',
                            color: 'rgba(26, 26, 26, 0.62)',
                        }}
                    >
                        Signed in as {user?.displayName || user?.email}
                    </Typography>
                </Box>
                <Stack direction="row" spacing={1} flexWrap="wrap">
                    <Button
                        component={RouterLink}
                        to="/admin"
                        size="small"
                        variant={isHome ? 'contained' : 'text'}
                        sx={galiaNavButtonSx(isHome)}
                    >
                        Home
                    </Button>
                    <Button
                        component={RouterLink}
                        to="/admin/litters"
                        size="small"
                        variant={isLitters ? 'contained' : 'text'}
                        sx={galiaNavButtonSx(isLitters)}
                    >
                        Planned litters
                    </Button>
                    <Button
                        component={RouterLink}
                        to="/admin/invite"
                        size="small"
                        variant={isInvite ? 'contained' : 'text'}
                        sx={galiaNavButtonSx(isInvite)}
                    >
                        Invite owner
                    </Button>
                    <Button
                        size="small"
                        onClick={() => void signOut()}
                        sx={{
                            ...galiaNavButtonSx(false),
                            color: brandColors.lavenderDark,
                        }}
                    >
                        Sign out
                    </Button>
                </Stack>
            </Stack>
            {children}
        </PageLayout>
    );
};

export default AdminLayout;
